const COLORS = {
  gray: '#808080',
  gray_3: '#3C4858',
  gray_4: '#8492A6',
  gray_5: '#C2CEDB',
  gray_6: '#D3DCE6',
  gray_7: '#D2D2D2',
  gray_8: '#EFF2F7',
  gray_9: '#636363',
  gray_50: '#F9FAFB',
  gray_200: '#EAECF0',
  gray_300: '#D0D5DD',
  gray_500: '#667085',
  gray_600: '#475467',
  gray_700: '#344054',
  gray_800: '#1D2939',
  gray_900: '#101828',
  gray_100: '#F9FAFC',
  light_gray: '#D3D3D3',
  dark_gray: '#A9A9A9',
  earlGray: '#92939D',
  blue_dark_500: '#2970FF',
  mercanto_blue: '#242A42',
  dark_red: '#AF3535',
  helperText_red: '#8B2A2A',
  light_red: '#F9EAEA',
  skyBlue: '#E4F1FF',
  blackish: '#121212',
  white: '#FFFFFF',
  green: '#769E91',
  adminGreen: '#6F9999',
  green_100: '#F3FBFB',
  green_200: '#C7DBDB',
  radiantGreen: '#24D366',
  sageGreen: '#63A89C',
  flowkit: {
    green: '#29CC6A',
    red: '#FC5555',
    blue: '#0099FF',
    purple: '#7B61FF',
    yellow: '#EAAA08',
    charcoal: '#222222',
    pink: '#9D174D',
  },
  gold: '#BF7300',
  olive: '#273D37',
  success_50: '#ECFDF3',
  success_200: '#ABEFC6',
  success_500: '#17B26A',
  success_700: '#067647',
  yellow_50: '#FEFBE8',
  yellow_200: '#FEEE95',
  yellow_700: '#A15C07',
  blue_700: '#026AA2',
  blue_50: '#F0F9FF',
  blue_200: '#B9E6FE',
  orange_700: '#B54708',
  orange_50: '#FFFAEB',
  orange_200: '#FEDF89',
  red_700: '#B42318',
  red_50: '#FEF3F2',
  red_200: '#FECDCA',
  orange_800: '#B93815',
  orange_100: '#FEF6EE',
  orange_300: '#F9DBAF',
  warning_50: '#FFFAEB',
  warning_200: '#FEDF89',
  warning_700: '#B54708',
  purple_light: '#E5E9F2',
  purple_middle: '#8c9eff',
  tableShadow: '#242A420A',

  foam: '#DDFBF4',
  neptune: '#71BDAB',
  deep_sea: '#028162',
  champagne: '#FAEAD1',
  chelsea_gem: '#A06000',
  link_water: '#D1E9FA',
  smalt: '#002DA0',
  smoky_topaz: '#9A3A3A',
};

export default COLORS;
